<script>
export default {
    props: [ 'data', 'value'],
    name: "filterTags",
    data() {
        return {};
    },
    computed: {
        show() { 
            return this.value.findIndex(v => v != null) != -1;
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        clearAll() {
            // this.tabActiveIndex = this.tabs.map(() => null);
            let _value = this.data.map(() => null);
            this.$emit('input', _value);
            this.$emit('change', _value);
        },
        close(index) { 
            // this.$set(this.tabActiveIndex, index, null);
            let _value = [...this.value];
            _value[index] = null;
            this.$emit('input', _value);
            this.$emit('change', _value);
        },
    },
};
</script>

<template>
    <div class="filter_tags flex flex_wrap" v-if="show">
        <div class="item layout_flex_center" v-for="(item, index) in value" :key="index" v-if="item != null">
            <p>{{ data[index].children[item].name }}</p>
            <div class="btn_close" @click="close(index)"></div>
        </div>
        <div class="btn_clear layout_flex_center" @click="clearAll"><span>清除全部</span></div>
    </div>
</template>

<style scoped lang="scss">
.filter_tags{
    gap: .16rem;
    font-size: .14rem;
    // margin-top: .2rem;
    .item{
        padding: 0 .05rem 0 .15rem;
        border-radius: .3rem;
        background: #dbdbdb;
        color: #666;
        line-height: 1;
        height: .3rem;
        .btn_close{
            width: .3rem;
            height: .3rem;
            position: relative;
            margin-left: .05rem;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 50%;
                border-bottom: 1px solid #666;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
    }
    .btn_clear{
        cursor: pointer;
        span{
            border-bottom: 1px solid #666;
        }
    }
    @media only screen and (max-width: 750px) {
        font-size: .22rem;
        .item{
            padding: 0 .4rem 0 .2rem;
            height: .44rem;
        }
    }
}
</style>